import { ReportActionButtons, ReportActivitiesButton, ReportSubmitButton } from '@views/expenseManagement/components'
import { isOwnerOrAdministrator, ReportStates, useGetReportQuery, useUserProfileQry } from 'mmfintech-backend-api'
import { useMemo } from 'react'

export const ReportHeaderButtons = ({ reportId }) => {
  const { profile, profileLoading } = useUserProfileQry()
  const { userPermissions, userId: profileUserId, customerRole } = profile || {}

  const { data: report } = useGetReportQuery({ reportId }, { skip: !reportId })
  const { state, approvalStatus, userId: reportUserId } = report || {}
  const { approvalLevelApprovers, hasMatrix, currentPriority } = approvalStatus || {}

  const isAlreadyApproved = useMemo(
    () => findApproverActionByUserId(profileUserId, approvalLevelApprovers),
    [profileUserId, approvalLevelApprovers]
  )

  const isApproverInMatrix = useMemo(
    () => findApproverInMatrix(profileUserId, approvalLevelApprovers, currentPriority),
    [profileUserId, approvalLevelApprovers, currentPriority]
  )

  const isOwner = useMemo(() => isOwnerOrAdministrator(customerRole), [customerRole])

  if (profileLoading) return null

  switch (state) {
    case ReportStates.NEW:
    case ReportStates.EDIT:
      return profileUserId === reportUserId ? (
        <>
          <ReportSubmitButton report={report} />
          {state === ReportStates.EDIT && <ReportActivitiesButton reportId={reportId} />}
        </>
      ) : null

    case ReportStates.WAITING_APPROVAL:
    case ReportStates.WAITING_FINANCE_APPROVAL:
      return !isAlreadyApproved &&
        reportUserId !== profileUserId &&
        (isOwner || (!isOwner && userPermissions.includes('APPROVER') && (isApproverInMatrix || !hasMatrix))) ? (
        <ReportActionButtons reportId={reportId} />
      ) : null

    default:
      return <ReportActivitiesButton reportId={reportId} />
  }
}

// TODO: Should be created better
function findApproverActionByUserId(userId, data) {
  // Iterate over the data to check each array of approvers
  for (const level in data) {
    // Iterate over each approver object in the array
    for (const approver of data?.[level] ?? []) {
      // If the userId matches, return the approverAction
      if (approver?.userId === userId) {
        return approver?.approverAction ?? null // Return the approverAction or null if not found
      }
    }
  }
  // If userId is not found, return null
  return null
}

function findApproverInMatrix(userId, data, currentPriority) {
  // Iterate over the data to check each array of approvers
  for (const level in data) {
    // Iterate over each approver object in the array
    for (const approver of data?.[level] || []) {
      // If the userId matches, return the approverAction
      if (approver?.userId === userId) {
        if (level >= currentPriority) {
          return approver
        }
      }
    }
  }
  // If userId is not found, return null
  return false
}
